module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/282ce9f1a37f6beb029c42fa61ee4369.png";